<template>
  <div class="danh-sach-cap-don-vi m-1 mt-3">
    <div class="row m-0 mt-1 mb-1">
      <div class="col col-3 pr-0">
        <div class="light-box">
          <div class="form">
            <DxTreeList
              id="treeList"
              :focused-row-enabled="checkValueDonVi"
              has-items-expr="Has_Items"
              :data-source="items"
              :column-auto-width="false"
              :word-wrap-enabled="false"
              :show-borders="false"
              :no-data-text="'Không có dữ liệu'"
              key-expr="id"
              parent-id-expr="parentId"
              :root-value="-1"
              :auto-expand-all="false"
              @focused-row-changed="onRowPrepared"
              :expanded-row-keys="expandedRowKeys"
            >
              <DxSearchPanel
                :visible="true"
                placeholder="Nhập từ khóa tìm kiếm"
                v-model="timKiem"/>
              <DxEditing
                :allow-ad="true"
                :select-text-on-edit-start="false"
                :use-icons="true"
                :auto-expand-all="false"
              >
              </DxEditing>
              <DxColumn
                :min-width="50"
                data-field="tenCapDonViCustom"
                caption="Thứ tự đơn vị"
                :allow-editing="true"
                :auto-expand-all="false"
                calculate-sort-value="thuTu"
                id="ten-don-vi"
                sort-order="asc"
                :cell-template="renderItem"
              >
              </DxColumn
            ></DxTreeList>
          </div>
        </div>
      </div>
      <div class="col col-9">
        <div class="light-box">
          <b-form-group class="border-bottom-form">
            <div v-if="isEdit === null" class="d-flex justify-content-end">
              <div class="ml-1 btn-tab-position-area top">
                <base-button
                  @click="openImport"
                  button="Import"
                  variant="info"
                  v-if="
                    hasPermissionUser(PERMISSION_NAME.IMPORT.IMPORT_CAP_DON_VI)
                  "
                />
                <base-button
                  class="btn btn-blue"
                  @click="openExport"
                  :disabled="isLoadingExport"
                  variant="info"
                  v-if="
                    hasPermissionUser(PERMISSION_NAME.IMPORT.EXPORT_CAP_DON_VI)
                  "
                  button="Export"
                >
                  <div class="d-flex">
                    <img
                      class="cursor-pointer"
                      width="16px"
                      src="@/assets/images/icon/export-icon.svg"
                      alt="image"
                    />
                    <span class="ml-1 mt-1"> Export</span>
                  </div>
                </base-button>
              </div>
              <div>
                <base-button button="Thêm mới" @click="themMoi()"></base-button>
                <base-button
                  button="Cập nhật"
                  @click="capNhat()"
                  v-if="capDonViDaChon"
                ></base-button>
                <base-button
                  v-if="capDonViDaChon"
                  button="Xóa"
                  @click="openDelete(capDonViDaChon)"
                ></base-button>
              </div>
            </div>
          </b-form-group>

          <FormCapNhatCapDonVi
            :data="capDonViDaChon"
            :is-edit.sync="isEdit"
            :danhSachCapDonVi="items"
            @refreshData="layDanhSachCapDonVi"
            @hidden="isEdit = null"
            ref="modalCapNhatCapDonVi"
          />
        </div>
      </div>
    </div>
    <div v-if="false">
      <p class="color-gray-1">Tìm thấy {{ totalRows }} kết quả</p>
      <DataTable
        :loading="isLoadingTable"
        :value="items"
        dataKey="id"
        class="p-datatable-customers"
      >
        <template #empty
          ><div class="text-center">Không có dữ liệu</div></template
        >
        <template #loading
          ><div class="text-center">Đang tải dữ liệu ...</div>
        </template>
        <Column
          field="id"
          dataKey="id"
          headerStyle="width: 40px"
          headerClass="p-2"
          header="STT"
          bodyStyle="text-align: center"
        >
          <template #body="slotProps">
            <span>{{
              (requestInformation.pageIndex - 1) * requestInformation.pageSize +
              slotProps.index +
              1
            }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="tenCapDonVi"
          header="Tên cấp đơn vị"
          headerStyle="minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestInformation.tenCapDonViFilter"
              @change="layDanhSachCapDonVi"
            />
          </template>
          <template #body="slotProps">
            <span>{{ slotProps.data.tenCapDonVi }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="maCapDonVi"
          header="Mã cấp đơn vị"
          headerStyle="minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestInformation.maCapDonViFilter"
              @change="layDanhSachCapDonVi"
            />
          </template>
          <template #body="slotProps">
            <span>{{ slotProps.data.maCapDonVi }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="thuTu"
          header="Thứ tự"
          headerStyle="width: 150px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestInformation.ThuTuFilter"
              @change="layDanhSachCapDonVi"
            />
          </template>
          <template #body="slotProps">
            <div class="text-center">
              <span>{{ slotProps.data.thuTu }}</span>
            </div>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="thaoTac"
          header="Thao tác"
          headerStyle="width: 100px"
          v-if="
            hasPermissionUser(PERMISSION_NAME.CAP_DON_VI.SUA) ||
            hasPermissionUser(PERMISSION_NAME.CAP_DON_VI.XOA)
          "
        >
          <template #body="slotProps">
            <div class="text-center">
              <font-awesome-icon
                icon="edit"
                v-b-popover.hover.top="'Cập nhật cấp đơn vị'"
                v-if="hasPermissionUser(PERMISSION_NAME.CAP_DON_VI.SUA)"
                class="cursor-pointer color-red"
                @click="openEdit(slotProps.data)"
              />
              <font-awesome-icon
                icon="trash-alt"
                v-b-popover.hover.top="'Xóa cấp đơn vị'"
                v-if="hasPermissionUser(PERMISSION_NAME.CAP_DON_VI.XOA)"
                class="cursor-pointer color-red ml-2"
                @click="openDelete(slotProps.data)"
              />
            </div>
          </template>
        </Column>
      </DataTable>
      <BasePagination
        class="mt-3"
        :current-page="requestInformation.pageIndex"
        :total-pages="totalPages"
        :total-rows="totalRows"
        @changeNum="onChangeNum($event)"
        @changePages="onChangePages($event)"
      />
    </div>
    <ModalCapNhatCapDonVi
      :data="capDonViDaChon"
      :is-edit.sync="isEdit"
      @hidden="isEdit = false"
      @refreshData="layDanhSachCapDonVi()"
      ref="modalCapNhatCapDonVi"
    />
    <ModalConfirm
      :title="(capDonViDaChon || {}).tenCapDonVi"
      @confirmed="xoaHeThong"
    />
    <ModalUploadImportFile
      ref="modalImport"
      :dataType="'CapDonVi'"
      :title="'Cấp đơn vị'"
      @refreshData="layDanhSachCapDonVi"
    />
    <div class="d-none">
      <b-icon v-show="isShow" icon="house-door" id="don-vi-icon" class="mr-2"> </b-icon>
    </div>
  </div>
</template>

<script>
import ModalCapNhatCapDonVi from "./modalCapNhatCapDonVi";
import FormCapNhatCapDonVi from "./FormCapNhatCapDonVi";
import ModalConfirm from "@/components/modal/ModalConfirm";
import ModalUploadImportFile from "@/components/modal/ModalUploadImportFile";
import {
  NO_RESULTS_TEXT,
  ROUTE_NAME,
  PERMISSION_NAME,
} from "@/constants/constants";
import { mapGetters } from "vuex";
import _isNil from "lodash/isNil";
import _isEmpty from "lodash/isEmpty";
import BasePagination from "@/components/common/BasePagination";
import { hasPermissionUser } from "@/utils/permissionUtils";
import {
  DxTreeList,
  DxEditing,
  DxColumn,
  DxSearchPanel,
} from "devextreme-vue/tree-list";

export default {
  name: "DanhSachChucVu",
  components: {
    ModalCapNhatCapDonVi,
    ModalConfirm,
    BasePagination,
    ModalUploadImportFile,
    DxTreeList,
    DxEditing,
    DxColumn,
    DxSearchPanel,
    FormCapNhatCapDonVi,
  },
  data() {
    return {
      isShow: false,
      i: 0,
      isLoadingExport: false,
      PERMISSION_NAME,
      isLoadingTable: true,
      ROUTE_NAME: ROUTE_NAME,
      NO_RESULTS_TEXT: NO_RESULTS_TEXT,
      requestInformation: {
        filterBy: "",
        pageSize: 10,
        pageIndex: 1,
      },
      totalPages: 0,
      totalRows: 0,
      sortableOptions: { chosenClass: "is-selected" },
      capDonViDaChon: null,
      isEdit: null,
      items: [],
      openModalDelete: false,
      expandedRowKeys: [-1],
      checkValueDonVi: true,
      timKiem: "",
    };
  },
  created() {
    this.layDanhSachCapDonVi();
  },
  computed: {
    ...mapGetters({
      danhSachCapDonVi: "capDonVi/danhSachCapDonViPaging",
    }),
    hasPageData() {
      return !_isEmpty(this.danhSachCapDonVi.items);
    },
  },
  methods: {
    hasPermissionUser,
    themMoi() {
      this.isEdit = false;
    },
    capNhat() {
      this.isEdit = true;
    },
    xoa() {},
    onChangeNum(pageSize) {
      this.requestInformation.pageIndex = 1;
      this.requestInformation.pageSize = pageSize;
      this.layDanhSachApp();
    },
    onChangePages(page) {
      this.requestInformation.pageIndex = page;
      this.layDanhSachApp();
    },
    layDanhSachCapDonVi(e) {
      this.isLoadingTable = true;
      if (e) {
        this.capDonViDaChon = e;
      }
      this.$store
        .dispatch("capDonVi/layDanhSachCapDonViPaging", this.requestInformation)
        .then(() => {
          this.isLoadingTable = false;
        });
    },
    openCreate() {
      this.isEdit = false;
      this.$refs["modalCapNhatCapDonVi"].$refs.modalCapNhatCapDonVi.show();
    },
    openImport() {
      this.$refs["modalImport"].showModal();
    },
    openExport() {
      let typeExport = "CapDonVi";
      this.isLoadingExport = true;
      this.$store
        .dispatch("importService/exportData", {
          type: typeExport,
          searchRequest: this.requestInformation,
        })
        .then((res) => {
          this.isLoadingExport = false;
          this.$toasted.global.showSuccessMessage({
            message: "Export thành công",
          });
          let url = window.URL.createObjectURL(new Blob([res.data]));
          let link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Export${typeExport}.xlsx`);
          document.body.appendChild(link);
          link.click();
        });
    },
    openEdit(item) {
      this.capDonViDaChon = item;
      this.isEdit = true;
      this.$refs["modalCapNhatCapDonVi"].$refs.modalCapNhatCapDonVi.show();
    },
    openDelete() {
      this.$bvModal.show("modal-confirm");
    },
    xoaHeThong(confirm) {
      if (confirm) {
        this.$store.dispatch("capDonVi/xoaCapDonVi", {
          data: { id: this.capDonViDaChon.id },
          onSuccess: this.onSuccess,
        });
        this.$bvModal.hide("modal-confirm");
      }
    },
    onSuccess() {
      this.layDanhSachCapDonVi();
    },
    capNhatThuTuCapDonVi() {
      let listUpdate = [];
      this.items.forEach(function(item, index) {
        listUpdate.push({ Id: item.id, ThuTu: index + 1 });
      });
      let payload = new FormData();
      payload.append("arrangeRequest", JSON.stringify(listUpdate));
      this.$store.dispatch("capDonVi/capNhatThuTu", {
        data: payload,
      });
    },
    layDanhSachCapDonViNoiBo(danhSachCapDonVi) {
      if (_isEmpty(danhSachCapDonVi.items)) {
        return [];
      }
      return danhSachCapDonVi.items.map((item, index) => {
        return {
          stt:
            (this.requestInformation.pageIndex - 1) *
              this.requestInformation.pageSize +
            index +
            1,
          parentId: item.parentId,
          tenCapDonVi: item.tenCapDonVi,
          tenCapDonViCha: item.tenCapDonViCha,
          tenCapDonViCustom: item.tenCapDonViCustom,
          maCapDonVi: item.maCapDonVi,
          id: item.id,
          thaoTac: null,
          thuTu: item.thuTu,
        };
      });
    },
    renderItem(element, data) {
      var icon = null;
      icon = document.getElementById("don-vi-icon").cloneNode(true);
      element.appendChild(icon);
      element.append(data.data.tenCapDonVi);
    },
    onRowPrepared(e) {
      this.capDonViDaChon = e.row.data;
    },
  },
  watch: {
    danhSachCapDonVi: {
      handler() {
        this.items = this.layDanhSachCapDonViNoiBo(this.danhSachCapDonVi);
        this.totalPages = this.danhSachCapDonVi.totalPage;
        this.totalRows = _isNil(this.danhSachCapDonVi.totalCount)
          ? 0
          : this.danhSachCapDonVi.totalCount;
      },
    },
  },
};
</script>
<style lang="scss">
.danh-sach-cap-don-vi {
  .btn-tab-position-area {
    &.top {
      top: -60px;
    }
    position: absolute;
    top: 11px;
  }
  .label {
    min-width: 130px;
    width: 130px;
    text-align: right;
  }
  .dx-toolbar-item-content > .dx-texteditor {
    width: 100% !important;
  }
  .dx-toolbar-after {
    padding: 0 !important;
    width: 100%;
  }
  .dx-treelist-search-panel {
    margin: 0 !important;
  }
  .custom-search {
    padding: 4px 8px;
    height: 35px;
    border-radius: 4px;
    border: 1px solid red;
  }
  .dx-treelist-cell-expandable {
    text-align: left !important;
  }
}
</style>
